import { render } from "./FilterDropdown.vue?vue&type=template&id=56d780fa"
import script from "./FilterDropdown.vue?vue&type=script&lang=js"
export * from "./FilterDropdown.vue?vue&type=script&lang=js"

import "./FilterDropdown.vue?vue&type=style&index=0&id=56d780fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__